import {
  Point,
  Loader,
  Texture,
  Ticker,
  WRAP_MODES,
  AnimatedSprite,
  BLEND_MODES,
} from 'pixi.js';
import eventHub from '@/scripts/eventHub';
import gsap from 'gsap';
import Actor from './Actor';
import vars from '../vars';
import FlowerGenerator from '../utils/FlowerGenerator';
import state from '../state';

class Floor extends Actor {
  constructor(parent, hitArea, renderer) {
    super(parent);
    this.hitArea = hitArea;
    this.frameHandler = () => { this.frame(); };

    this.ref = new global.PIXI.projection.Container2d();

    const whiteTexture = new Texture(Texture.EMPTY.baseTexture);
    whiteTexture.orig.width = vars.layout.STAGE_WIDTH / 1.5;
    whiteTexture.orig.height = vars.layout.STAGE_HEIGHT * 2.5;
    this.sprite = new global.PIXI.projection.Sprite2d(whiteTexture);

    const floorTexture = Loader.shared.resources['images/FLOOR'].texture;
    floorTexture.baseTexture.wrapMode = WRAP_MODES.REPEAT;
    this.floor = new global.PIXI.projection.TilingSprite2d(
      floorTexture,
      vars.layout.STAGE_WIDTH,
      vars.layout.STAGE_HEIGHT,
    );

    this.lightDiscTextures = Object.values(Loader.shared.resources['video/LIGHT_DISC'].spritesheet.textures);
    this.lightDiscWideTextures = Object.values(Loader.shared.resources['video/LIGHT_DISC_WIDE'].spritesheet.textures);
    this.lightDiscFarTextures = Object.values(Loader.shared.resources['video/LIGHT_DISC_FAR'].spritesheet.textures);

    // Pre-upload all the textures to the GPU
    this.lightDiscTextures.forEach((t) => { renderer.plugins.prepare.upload(t); });
    this.lightDiscWideTextures.forEach((t) => { renderer.plugins.prepare.upload(t); });
    this.lightDiscFarTextures.forEach((t) => { renderer.plugins.prepare.upload(t); });

    this.sprite.addChild(this.floor);
    this.ref.addChild(this.sprite);

    this.lightDisc = new AnimatedSprite(this.lightDiscTextures);
    this.lightDisc.alpha = 0;
    this.lightDisc.blendMode = BLEND_MODES.ADD;
    this.lightDisc.loop = false;
    this.sprite.addChild(this.lightDisc);

    this.setPerspective(true);
    this.resize();
    this.parent.ref.addChild(this.ref);

    this.generator = new FlowerGenerator(this.sprite, this.hitArea);

    Ticker.shared.add(this.frameHandler);

    this.fireRayHandler = () => this.fireRay();
    this.stopRayHandler = () => this.stopRay();
    this.rayPowerHandler = () => this.powerStart();
    this.rayWideHandler = () => this.wideStart();
    this.rayFarHandler = () => this.farStart();
    this.stopPowerUpHandler = () => this.stopPowerUp();
    eventHub.$on('fire-ray', this.fireRayHandler);
    eventHub.$on('stop-ray', this.stopRayHandler);
    eventHub.$on('ray-power', this.rayPowerHandler);
    eventHub.$on('ray-wide', this.rayWideHandler);
    eventHub.$on('ray-far', this.rayFarHandler);
    eventHub.$on('stop-power-up', this.stopPowerUpHandler);
  }

  resize() {
    this.sprite.anchor = new Point(0.5, 0.5);
    this.sprite.position.x = vars.layout.STAGE_WIDTH / 2;
    this.sprite.position.y = vars.layout.STAGE_HEIGHT / 2;

    this.floor.anchor = new Point(0.5, 0.5);

    this.lightDisc.anchor = new Point(0.5, 1);
    this.lightDisc.position.y = 220;
  }

  startSpawning() {
    this.generator.start();
  }

  stopSpawning() {
    this.generator.stop();
  }

  frame() {
    this.floor.tilePosition.y += state.speed;
    this.lightDisc.gotoAndStop(state.currentLightFrame);
  }

  fireRay() {
    gsap.to(this.lightDisc, { alpha: 0.05, ease: 'power2.out', duration: 0.8 });
  }

  stopRay() {
    gsap.to(this.lightDisc, { alpha: 0, ease: 'power2.out', duration: 0.8 });
  }

  powerStart() {
    // this.lightDisc.tint = 0xff0000;
  }

  wideStart() {
    this.lightDisc.textures = this.lightDiscWideTextures;
    this.lightDisc.gotoAndStop(state.currentLightFrame);
  }

  farStart() {
    this.lightDisc.textures = this.lightDiscFarTextures;
    this.lightDisc.gotoAndStop(state.currentLightFrame);
  }

  stopPowerUp() {
    this.lightDisc.tint = 0xffffff;
    this.lightDisc.textures = this.lightDiscTextures;
    this.lightDisc.gotoAndStop(state.currentLightFrame);
  }

  destroy() {
    eventHub.$off('fire-ray', this.fireRayHandler);
    eventHub.$off('stop-ray', this.stopRayHandler);
    eventHub.$off('ray-power', this.rayPowerHandler);
    eventHub.$off('ray-wide', this.rayWideHandler);
    eventHub.$off('ray-far', this.rayFarHandler);
    eventHub.$off('stop-power-up', this.stopPowerUpHandler);
    Ticker.shared.remove(this.frameHandler);
    // this.generator.destroy();
    this.ref.destroy({ chidlren: true });
  }
}

export default Floor;
